
import { API_URL } from "../utils/auth";
export async function fetchPublicSettings({ signal } = {}) {
  const response = await fetch(`${API_URL}/settings/public/`, { headers: { Accept: "application/json" }, signal });
  const data = await response.json();
  if (!response.ok) throw new Error(data?.error?.message || data?.detail || "Settings could not be loaded.");
  return data;
}
